import { WidgetControlType } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Linear function preset demonstrating slope as rate of change.
 * Features: roots, y-intercept, secant with rate triangle.
 */
export const LINEAR_PRESET: GraphpadWidgetConfig = {
  id: 'linear',
  type: 'graphpad',
  params: {
    f: {
      type: 'linear',
      params: { m: 2, b: -2 },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
    'f-yintercept': {
      type: 'yIntercept',
      params: { of: 'f' },
    },
    'f-secant': {
      type: 'secant',
      params: { of: 'f', xStart: 2, xEnd: 3, finite: false, showRateTriangle: true },
    },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -4, xEnd: 6, yStart: -4, yEnd: 8 },
      grid: { type: 'lines', visible: true },
      axes: true,
    },
    elements: {
      f: {},
      'f-roots': {
        point: {
          color: 'teal',
          label: { contentVariant: 'name+coord', position: 'topLeft' },
        },
      },
      'f-yintercept': {
        point: {
          label: { contentVariant: 'name+coord', position: 'topLeft' },
        },
      },
      'f-secant': {
        subparts: {
          startPoint: { visible: true },
          endPoint: { visible: true },
          secantLine: { visible: false },
          rateTriangle: {
            visible: true,
            subparts: {
              horizontalLine: {
                line: {
                  label: { text: 'Δx = {length}', position: 'bottom', color: 'pink', variant: 'secondary' },
                },
              },
              verticalLine: {
                line: {
                  label: { text: 'Δy = {length}', position: 'right', color: 'pink', variant: 'secondary' },
                },
              },
              cornerPoint: { visible: false },
            },
          },
        },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-m',
        type: WidgetControlType.Slider,
        label: 'm',
        param: 'f.m',
        range: [-5, 5, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'sky',
      },
      {
        id: 'slider-b',
        type: WidgetControlType.Slider,
        label: 'b',
        param: 'f.b',
        range: [-6, 6, 0.5],
        defaultValue: -2,
        editable: true,
        color: 'green',
      },
    ],
  },
};
